import { Component, OnInit, Input } from '@angular/core';
import { SchemaField, Document } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'app-date-time-column',
    templateUrl: './date-time-column.component.html',
    styleUrls: ['./date-time-column.component.scss'],
    standalone: false
})
export class DateTimeColumnComponent implements OnInit, DynamicColumn {
  @Input() field: SchemaField;
  @Input() document: Document;

  get fieldValue(): string {
    return this.document?.[this.field.systemName];
  }

  get format(): string {
    let dateFormat = this.field?.settings?.format;
    if (!dateFormat) {
      dateFormat = 'LONG-DATE-WITH-TIME';
    }

    return dateFormat;
  }

  constructor() {}

  ngOnInit(): void {}
}
